export default __webpack_public_path__ + "static/media/no-records.8a96d46c.png";